export const EvaUserAccountType = {
  Standard: 0 as EVA.Core.UserAccountType.Standard,
  Basic: 1 as EVA.Core.UserAccountType.Basic,
  Incognito: 2 as EVA.Core.UserAccountType.Incognito,
};
